var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M470-265.5h22V-469l95 95.5 16.5-16-123-122-122 123L373-373l97-96v203.5ZM265.8-132q-22.04 0-37.92-15.88Q212-163.76 212-185.78v-588.44q0-22.02 15.88-37.9Q243.76-828 266-828h326l156 155.5V-186q0 22.24-15.88 38.12Q716.24-132 694.2-132H265.8ZM581-662v-144H266q-12 0-22 10t-10 22v588q0 12 10 22t22 10h428q12 0 22-10t10-22v-476H581ZM234-806v144-144 652-652Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.f4c36a6dc9f52467f2dc70e822f4d6e5.svg";
export { ForwardRef as ReactComponent };